import { useI18n } from './useI18n';

export type UsingTypeKey =
  | 'campaign'
  | 'offer'
  | 'flow'
  | 'landing'
  | 'trafficSource'
  | 'affiliateNetwork'
  | 'trackingDomain';

export const useGetUsingType = () => {
  const { t } = useI18n();

  const getUsingType = ({ type }: { type: string }) => {
    switch (type) {
      case 'campaign':
        return t('Campaign');
      case 'offer':
        return t('Offer');
      case 'flow':
        return t('Flow');
      case 'landing':
        return t('Landing');
      case 'trafficSource':
        return t('Traffic Source');
      case 'affiliateNetwork':
        return t('Affiliate Network');
      case 'trackingDomain':
        return t('Tracking domain');
      default:
        return '';
    }
  };

  return { getUsingType };
};
